class ScheduleSaveController {

    constructor() {
        this.view = new ScheduleSaveView(this.onSave.bind(this));
    }

    onSave() {
        plannerApplication.api.saveProfile();
        let url = this.view.showSaved();
        window.history.replaceState(null,'',url);
    }
}
